// eslint-disable-next-line arrow-body-style
export const escapeWord = (array: string[]): string[] => {
  return array.map((str) => {
    const isNegation = str.startsWith('-')
    const word = isNegation ? str.slice(1) : str
    const escaped = word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    return isNegation ? `-${escaped}` : escaped
  })
}

// eslint-disable-next-line arrow-body-style
export const compile = (conditions: string[], isAnd = true): RegExp => {
  let rx
  const trimmedConditions = conditions.filter((v) => v !== "")
  if (isAnd) {
    const joinAnd = (arr: string[]) => `^(?=[\\s\\S]*${escapeWord(arr).join(')(?=[\\s\\S]*')})`
    rx = joinAnd(trimmedConditions).replace(/=\[\\s\\S\]\*-/g, '![\\s\\S]*')
  } else {
    const joinOr = (arr: string[]) => `^(?=[\\s\\S]*(${escapeWord(arr).join('|')}))`
    rx = joinOr(trimmedConditions).replace(/=\[\\s\\S\]\*-/g, '![\\s\\S]*')
  }
  return new RegExp(rx)
}
